"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useAuthState;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _context = _interopRequireDefault(require("../context"));

function useAuthState() {
  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isAuth = _useState2[0],
      setIsAuth = _useState2[1];

  var _useContext = (0, _react.useContext)(_context["default"]),
      app = _useContext.app;

  (0, _react.useEffect)(function () {
    var unsubscribe = app.auth().onAuthStateChanged(function (user) {
      if (user) {
        return setIsAuth(true);
      }

      return setIsAuth(false);
    });
    return function () {
      return unsubscribe();
    };
  }, [app]);
  return isAuth;
}